import { PendingBillsModel } from 'one-card-pending-bills';

/**
 * This Function transforms the backend response
 * in the Data Model that supports the
 *Pending Bills Component
 * @param response has the backend
 * pending bills response
 * @param context has settings etc...
 */


export const TransformResponse = (response: any, context: any) => {

    /**
     * @param result contains the transformed response
     */
    let pendingbills: PendingBillsModel = { totalpendingbills: 0, totalbalance: 0 };

    let result: any = {
        bills: pendingbills,
        error: undefined

    }
    if (response && response.length > 0) {
        let sbototalbalance = 0,
            sbototalpendingbal = 0,
            sbopendingbill: [],
            sbototalpendingbills = 0;
        let hbtotalbalance = 0,
            hbtotalpendingbal = 0,
            hbpendingbill: [],
            hbtotalpendingbills = 0;
        let pbtotalbalance = 0,
            pbtotalpendingbal = 0,
            pbtotalpendingbills = 0;
        let sboinsurancebalance = 0;
        let hbinsurancebalance = 0;
        let pbinsurancebalance = 0;
        let servicearea = "";
        response.map((ele: any) => {
            if (ele?.GuarantorAccounts) {
                if (ele.GuarantorAccounts.length > 0) {
                    ele.GuarantorAccounts.map((duedata: any) => {
                        if (duedata?.SingleBillingOffice?.OutstandingAccount?.Accounts) {
                            // sboinsurancebalance = sboinsurancebalance + duedata.SingleBillingOffice.OutstandingAccount.InsuranceBalance;
                            // sbototalbalance = sbototalbalance + duedata.SingleBillingOffice.OutstandingAccount.PatientBalance;
                            if (!servicearea) {
                                servicearea = duedata.ServiceArea?.Name
                            }
                            sbopendingbill = duedata.SingleBillingOffice.OutstandingAccount.Accounts;
                            duedata?.SingleBillingOffice?.OutstandingAccount?.Accounts?.map((sbo: any) => {  
                                sboinsurancebalance +=  sbo.InsuranceBalance ? parseFloat(sbo.InsuranceBalance) : 0;
                                sbototalbalance += sbo.PatientBalance ? parseFloat(sbo.PatientBalance) : 0;
                             })
                            sbopendingbill.map((dueamount: any) => {
                                sbototalpendingbal = sbototalpendingbal + 1;
                                sbototalpendingbills = sbototalpendingbal
                            })
                        }

                        if (duedata?.HospitalBilling?.OutstandingAccount?.Accounts) {
                            // Sum balances from the Accounts array for Hospital Billing
                            duedata.HospitalBilling.OutstandingAccount.Accounts.forEach((hbAccount: any) => {
                                hbinsurancebalance = hbinsurancebalance + (hbAccount?.InsuranceBalance ? parseFloat(hbAccount.InsuranceBalance) : 0);
                                hbtotalbalance = hbtotalbalance + (hbAccount?.PatientBalance ? parseFloat(hbAccount.PatientBalance) : 0);
                            });
                            
                            if (!servicearea) {
                                servicearea = duedata.ServiceArea?.Name
                            }
                            hbpendingbill = duedata.HospitalBilling.OutstandingAccount.Accounts;

                            hbpendingbill.map((dueamount: any) => {
                                hbtotalpendingbal = hbtotalpendingbal + 1;
                                hbtotalpendingbills = hbtotalpendingbal
                            })
                        }

                        if (duedata?.ProfessionalBilling?.TransactionSummary) {
                            pbinsurancebalance = pbinsurancebalance + duedata.ProfessionalBilling.TransactionSummary.InsuranceBalance;
                            pbtotalbalance = pbtotalbalance + duedata.ProfessionalBilling.TransactionSummary.PatientBalance;
                            if (!servicearea) {
                                servicearea = duedata.ServiceArea?.Name
                            }
                            if (duedata.ProfessionalBilling.TransactionSummary.Patients &&
                                duedata.ProfessionalBilling.TransactionSummary.Patients.length > 0) {
                                duedata.ProfessionalBilling.TransactionSummary.Patients.map((pat: any) => {
                                    if (pat?.Visits &&
                                        pat.Visits.length > 0) {
                                        pat.Visits.map((visit: any) => {
                                            if (visit?.Charges &&
                                                visit.Charges.length > 0) {
                                                visit.Charges.map((pbhb: any) => {
                                                    pbtotalpendingbal = pbtotalpendingbal + 1;
                                                    pbtotalpendingbills = pbtotalpendingbal
                                                })
                                            }
                                        })
                                    }
                                })
                            }
                        }

                    })
                }


            }
        })
        pendingbills['totalpendingbills'] = sbototalpendingbills + hbtotalpendingbills + pbtotalpendingbills;
        pendingbills['totalbalance'] = parseFloat((sbototalbalance + hbtotalbalance + pbtotalbalance).toFixed(2));
        pendingbills['insurancebalance'] = parseFloat((sboinsurancebalance + hbinsurancebalance + pbinsurancebalance).toFixed(2));
        pendingbills['servicearea'] = servicearea;
    }
    result.bills = pendingbills;
    return result;
}